import MailTemplateService from "@/services/MailTemplateService.js";

const state = {
  templates: [],
  searchText: ""
};

const getters = {
  getTemplateList(state) {
    return state.templates;
  },
  getSearch(state) {
    return state.searchText;
  }
};

const actions = {
  fetchTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      MailTemplateService.getAll()
        .then(response => {
          commit("SET_TEMPLATE_LIST", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const mutations = {
  SET_TEMPLATE_LIST(state, value) {
    state.templates = value;
  },
  SET_SEARCH(state, value) {
    state.searchText = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
